import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterSelect } from './filters/lightbox_filter_select';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';
import { addLoadIndexAbsoluteValueToLabel } from '../../../../../_modules/tyre_index/add_load_index_absolute_value_to_label';
import { map } from '../../../../../../lib/utilities';


function LightboxTyreUsage(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.USAGE_VIEW];
    const translationKey = FilterLabelTranslationKeys[Filters.USAGE];
    const unavailableUsages = (TYROOLA.initialFluxStates.filter.unavailableUsages) ? TYROOLA.initialFluxStates.filter.unavailableUsages : [];


    const options = map(props.options, option => [option[0], addLoadIndexAbsoluteValueToLabel(option[0])]);


    return (
        <LightboxView
            viewName={FilterSections.USAGE_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                <LightboxFilterSelect
                    name={Filters.USAGE}
                    value={props.value}
                    options={props.options}
                    labelTranslationKey={translationKey}
                    provideAllTranslationKey={translationKey}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={unavailableUsages}
                />
            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
            />
        </LightboxView>
    );
}

LightboxTyreUsage.propTypes = {
    value: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxTyreUsage };
